module.exports = __webpack_public_path__ + "img/qrcode.00d06b4a.jpg";